import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { Icon } from "../../../components/icons";
import { MORE_FEATURES } from "../content";
import { prefersReducedMotion } from "../hooks";
import "./MoreFeatures.css";

/** En celular se ven estas primeras y el resto con «Ver las 12 funciones». */
const MOBILE_VISIBLE = 6;

/** Y además (#funciones): 12 funciones en mosaicos. En celular muestra 6 y un
 * botón para ver las demás. */
export function MoreFeatures() {
  const [expanded, setExpanded] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const collapsedOnce = useRef(false);

  // Al cerrar la lista, el botón sube: se deja a la vista para no perder el
  // lugar en la página.
  useEffect(() => {
    if (expanded || !collapsedOnce.current) return;
    const frame = window.requestAnimationFrame(() => {
      toggleRef.current?.scrollIntoView({ block: "nearest", behavior: prefersReducedMotion() ? "auto" : "smooth" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [expanded]);

  const toggle = () => {
    if (expanded) collapsedOnce.current = true;
    setExpanded((value) => !value);
  };

  return (
    <section id="funciones" className="t123-section t123-section--soft t123-features" aria-labelledby="t123-features-title">
      <div className="t123-shell">
        <div className="t123-heading-center">
          <h2 id="t123-features-title" className="t123-h2">
            Y además
          </h2>
        </div>

        <ul id="t123-features-list" className={`t123-features__grid${expanded ? " is-expanded" : ""}`}>
          {MORE_FEATURES.map((item, index) => (
            <li
              key={item.title}
              className={`t123-features__item${index >= MOBILE_VISIBLE ? " t123-features__item--extra" : ""}`}
            >
              <span className="t123-tile-icon" aria-hidden="true">
                <Icon name={item.icon} />
              </span>
              <div>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="t123-features__foot">
          <button
            ref={toggleRef}
            type="button"
            className="t123-btn t123-btn--outline t123-features__toggle"
            aria-expanded={expanded}
            aria-controls="t123-features-list"
            onClick={toggle}
          >
            {expanded ? "Ver menos" : `Ver las ${MORE_FEATURES.length} funciones`}
          </button>
          <Link className="t123-link-arrow t123-features__guide" to="/guia">
            Consulta la guía ilustrada del organizador
          </Link>
        </div>
      </div>
    </section>
  );
}
